"use client"

import { useEffect, useState } from "react"
import { io, Socket } from "socket.io-client"

export interface MprcData {
  [nodeId: string]: boolean | string | number | null
}

export interface MprcState {
  data: MprcData
  isConnected: boolean
}

let socket: Socket | null = null

export function useMprcSocket(): MprcState {
  const [data, setData] = useState<MprcData>({})
  const [isConnected, setIsConnected] = useState(false)

  useEffect(() => {
    if (!socket) {
      socket = io(window.location.origin, {
        path: "/socket.io",
        transports: ["websocket", "polling"],
      })
    }

    const onConnect = () => setIsConnected(true)
    const onDisconnect = () => setIsConnected(false)

    const onMprcData = (payload: { nodeId: string; value: boolean | string | number | null }) => {
      setData((prev) => ({ ...prev, [payload.nodeId]: payload.value }))
    }

    const onMprcStatus = (payload: { connected: boolean }) => {
      setIsConnected(payload.connected)
    }

    socket.on("connect", onConnect)
    socket.on("disconnect", onDisconnect)
    socket.on("mprc_data", onMprcData)
    socket.on("mprc_status", onMprcStatus)

    return () => {
      socket?.off("connect", onConnect)
      socket?.off("disconnect", onDisconnect)
      socket?.off("mprc_data", onMprcData)
      socket?.off("mprc_status", onMprcStatus)
    }
  }, [])

  return { data, isConnected }
}
